/**
 * Helpers for serializing list-page filter state (Sets, URL link context).
 */

/** @param {Set<string>|undefined|null} set */
export function setToStringArray(set) {
  if (!set || !(set instanceof Set) || set.size === 0) return [];
  return [...set].map((x) => String(x));
}

/** @param {unknown} value */
export function stringArrayToSet(value) {
  if (!Array.isArray(value) || value.length === 0) return new Set();
  return new Set(value.map((x) => String(x)).filter(Boolean));
}

/**
 * True when any of the given query param keys has a non-empty value (deep-link / drill-down context).
 * @param {URLSearchParams} searchParams
 * @param {string[]} paramKeys
 */
export function hasSearchParamContext(searchParams, paramKeys) {
  if (!searchParams || !Array.isArray(paramKeys)) return false;
  for (const key of paramKeys) {
    const v = searchParams.get(key);
    if (v != null && String(v).trim() !== "") return true;
  }
  return false;
}

const NAV_VIEWS = new Set(["day", "week", "month", "future", "all"]);

/** @param {unknown} view */
export function normalizeNavView(view) {
  const v = view != null ? String(view).trim().toLowerCase() : "";
  return NAV_VIEWS.has(v) ? v : null;
}

/** @param {unknown} status */
export function normalizeOpenClosedStatus(status) {
  const v = status != null ? String(status).trim().toLowerCase() : "";
  return v === "open" || v === "closed" || v === "all" ? v : null;
}

/** @param {unknown} mode */
export function normalizeViewMode(mode, allowedModes) {
  const v = mode != null ? String(mode).trim().toLowerCase() : "";
  const allowed = Array.isArray(allowedModes) ? allowedModes : [];
  return allowed.includes(v) ? v : null;
}
